import { interval, timeout } from './observable';

const ReadyStateEnum = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

class WebsocketService {
  constructor(options) {
    this.url = options.url;
    this.protocols = options.protocols;
    this.queueMessage = [];
    this.subscribers = {};
    this.params = {};
    this.ws = undefined;
  }

  connect() {
    if (
      this.ws?.readyState !== ReadyStateEnum.CLOSED &&
      this.ws?.readyState !== undefined
    )
      return;

    this.ws = new WebSocket(this.url, this.protocols);

    this.ws.addEventListener('open', () => {
      if (Object.keys(this.params).length > 0) {
        this.ws?.send(
          JSON.stringify({
            event: 'sub',
            topic: 'STOCK_RETIME_LIST',
            params: Object.keys(this.params),
          }),
        );
      }
    });

    this.ws.addEventListener('error', () => {});

    this.ws.addEventListener('close', () => {
      timeout(2000).subscribe(() => this.connect());
    });

    this.ws.addEventListener('message', (ev) => {
      Object.values(this.subscribers).forEach((subscriber) =>
        subscriber.callback(ev),
      );
    });

    interval(60000).subscribe(() => {
      if (this.ws?.readyState === ReadyStateEnum.OPEN) {
        this.ws?.send(JSON.stringify({ event: 'ping' }));
      }
    });

    interval(100).subscribe(() => {
      if (
        this.ws?.readyState === ReadyStateEnum.OPEN &&
        this.queueMessage.length > 0
      ) {
        const request = this.queueMessage.shift();
        this.ws?.send(request);
      }
    });
  }

  addSubscriber(id) {
    const uuid = `${id}_${Date.now()}`;
    const subscriber = {
      id: uuid,
      params: [],
      callback: () => null,
    };
    this.subscribers[uuid] = subscriber;

    return {
      send: (data) => this.send(uuid, data),
      subscribe: (callback) => {
        if (this.subscribers && this.subscribers[uuid]) {
          this.subscribers[uuid].callback = callback;
        }
      },
      unsubscribe: () => {
        this.unsubscribe(uuid);
      },
    };
  }

  unsubscribe(id) {
    if (!this.subscribers[id]) return;
    const subscriberParams = this.subscribers[id]?.params;
    const unsubParams = [];
    if (subscriberParams) {
      subscriberParams.forEach((param) => {
        this.params[param]--;
        if (this.params[param] === 0) {
          unsubParams.push(param);
          delete this.params[param];
        }
      });
    }
    if (unsubParams.length > 0) {
      this.queueMessage.push(
        JSON.stringify({
          event: 'unsub',
          topic: 'STOCK_RETIME_LIST',
          params: unsubParams,
        }),
      );
    }
    delete this.subscribers[id];
  }

  send(id, data) {
    try {
      const request = typeof data === 'string' ? JSON.parse(data) : data;
      const newParams = [];

      const subscriberParams = this.subscribers[id]?.params;
      if (subscriberParams) {
        request?.params?.forEach((param) => {
          if (!this.params[param]) {
            this.params[param] = 1;
            newParams.push(param);
          } else {
            this.params[param]++;
          }
          if (!subscriberParams.includes(param)) {
            subscriberParams.push(param);
          }
        });
        this.subscribers[id].params = subscriberParams;
      }
      if (newParams.length > 0) {
        this.queueMessage.push(
          JSON.stringify({
            event: 'sub',
            topic: 'STOCK_RETIME_LIST',
            params: newParams,
          }),
        );
      }
    } catch (error) {
      console.error('Failed to send data:', error);
    }
  }
}

export default WebsocketService;
